import { ArrowRight, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const ICFAnnouncementCard = () => {
  return (
    <Card className="bg-gradient-to-br from-primary/5 to-primary/10 border-primary/20">
      <CardHeader>
        <CardTitle className="text-2xl md:text-3xl font-bold text-primary">
          L'indice de la Citoyenneté Française 2025 est paru !
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-base md:text-lg text-foreground/90 leading-relaxed">
          Pour aborder ces sujets factuellement, sans ressenti, <strong>nous avons créé l'Indice de Citoyenneté Française (ICF)</strong>, 
          miroir de notre relation aux principes républicains, à notre modèle de société qui aspire à la Liberté, 
          à la dignité des individus et à la cohésion sociale dans un état de droit. Pas un sondage. Pas une pétition. 
          Un indice, chiffré, sourcé, public, suivi année après année.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <a 
            href="https://jqswmyqzmjdstetjqzvv.supabase.co/storage/v1/object/public/edlr-icf2025/EDLR_ICF2025.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-primary hover:bg-primary/90 text-primary-foreground px-6 py-3 rounded-lg font-medium transition-colors"
          >
            Lire le dossier complet
            <ArrowRight className="ml-2" size={20} />
          </a>
          
          <a 
            href="https://www.marianne.net/agora/tribunes-libres/plus-de-droits-moins-de-devoirs-un-nouvel-indice-revele-une-citoyennete-desequilibree"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-secondary hover:bg-secondary/90 text-secondary-foreground px-6 py-3 rounded-lg font-medium transition-colors"
          >
            Publication dans Marianne
            <ExternalLink className="ml-2" size={20} />
          </a>
        </div>
      </CardContent>
    </Card>
  );
};
